angular.module('qkr').controller('templateController', ['$routeParams', 'formBuilderService', '$timeout', 'isCopy', function($routeParams, formBuilderService, $timeout, isCopy) {
	const self = this;
	
	self.loaded = false;
	self.template = null;
	if ($routeParams.templateId) {
		formBuilderService.getTemplate($routeParams.templateId).then((response) => {
			if (isCopy) {
				self.template = stripIds(response.data);
			} else {
				self.template = response.data;
			}
            self.template.isSignatureRequired = false;
            for (let i = 0; i < self.template.formElements.length; i++) {
                const el = self.template.formElements[i];
                if (el.type == 'Signature') {
                    self.template.isSignatureRequired = true;
                }
            }

			$timeout(() => {
				self.loaded = true;
			}, 100);
		});
	} else {
		const template = {};
		template.name = '';
		template.formElements = [];
		self.template = template;
		
		$timeout(() => {
			self.loaded = true;
		}, 100);
	}
	
	function stripIds(template) {
		delete (template.id);
		
		angular.forEach(template.formElements, (formElement) => {
			delete (formElement.id);
		});
		
		return template;
	}
}]);



// WEBPACK FOOTER //
// ./src/controllers/template.controller.js